/**
 * Created with IntelliJ IDEA.
 * User: noam
 * Date: 1/14/14
 * Time: 5:02 PM
 * To change this template use File | Settings | File Templates.
 */

define(function (require) {
    "use strict";

    var LE = require("app");
    var RevisionedModel = require("models/RevisionedModel");
    var ApiResources = require("assets/data/apiResources.json");
    var ContentCannedBaseModel = require("content-models/canned/ContentCannedBaseModel");
    var ContentCannedUtilities = require("content-utils/ContentCannedUtilities");
    var validationConfig = require("content-assets/config/contentCannedValidationConfig.json");
    var LocaleResolver = require("i18n/localeResolver");
    var CONST = require("const");

    var KEYS = {
        TYPE: "type",
        TITLE: "title",
        CATEGORIES: "categoriesIds",
        HOTKEYS: "hotkey",
        SKILLS: "skillIds",
        LOBS: "lobIds"
    };
    var CANNED_TYPES = {
        TEXT: 0
    };

    var CANNED_TYPE_NAMES = {} ;
    CANNED_TYPE_NAMES[CANNED_TYPES.TEXT] = "text";


    var ContentCannedModel = {};
    LE.module("LEContent", function (LEContent, LE, Backbone, Marionette, $, _) {

        ContentCannedModel = ContentCannedBaseModel.extend({
            resource: ApiResources.AccountConfig.CannedMessages,
            name: "ContentCannedModel",
            defaults : {
              //  id: null, //new model id must be null so model.isNew() wil work
                "deleted": false,
                "enabled": true,
                "type": CANNED_TYPES.TEXT,
                "data": [],
                "categoriesIds": [],
                "skillIds": [],
                "lobIds": []

            },

            initialize: function(options){
                ContentCannedBaseModel.prototype.initialize.call(this, options);
            },
            url: function(){
                var url = ContentCannedBaseModel.prototype.url.call(this);
                return url+= "&lang="+ LE.siteSettings.supportedLanguageSettings.getSupportedLanguageCodes().join(",");
            },

            validateSaveEnabled:function () {
                var saveEnabled = false;
                //for new canned allow save only if have both title and text for at least one language
                if (this.isNew()) {
                    var langCodes = LE.siteSettings.supportedLanguageSettings.getSupportedLanguageCodes();
                    //need to iterate only on allowed languages and use the has content function
                    saveEnabled = _.some(langCodes, function (langCode, index, list) {
                        return this.hasContent(langCode);
                    }, this);
                }  else{
                    //when editing an existing canned response allow the save button after any change.
                    saveEnabled = true;
                }

                return saveEnabled;
            },
            getValidationConfig: function(){
                return validationConfig;
            },
            hasContentOrTitleForIndex: function(idx) {
                var lang = this.getData()[idx][ContentCannedBaseModel.KEYS.LANG];
                return  this.hasContentOrTitle(lang);
            },
            hasContent: function(lang){
                return this.hasContentMessage(lang) &&
                    this.hasContentTitle(lang);
            },
            hasContentTitle: function(lang){
                return this.hasLanguage(lang) &&
                    this.getContentTitle(lang).length > 0;
            },
            hasContentOrTitle: function(lang){
                return this.hasContentMessage(lang) ||
                    this.hasContentTitle(lang);
            },
            hasTitleField: function() {
                return true;
            },
            getEmptyContent: function(){
                return {"msg": "","title" : "",isDefault:false};
            },
            getContentHotkeys: function(){
                return this.get(KEYS.HOTKEYS);
            },
            setContentHotkeys: function(hotkeys){
                if(hotkeys.prefix){
                    this.set(KEYS.HOTKEYS, {"prefix": hotkeys.prefix, "suffix": hotkeys.suffix});
                }
                else{
                    this.unset(KEYS.HOTKEYS);
                }
            },
            isHotkeyPrefixSet: function(){
                return !!this.get(KEYS.HOTKEYS);
            },
            getContentTitle: function(lang){
                if (this.hasLanguage(lang)){
                    var title = this.get(this.getContentTitleKey(lang));
                    return title? title:"";
                }  else {
                    return "";
                }
            },

            setContentTitle: function(lang,title){
                if (!this.hasLanguage(lang)){
                    this._addNewContent(lang);
                }
                this.set(this.getContentTitleKey(lang),title);
                this.set(this._getIsDefaultKey(lang),false); //language content was updated we are not default anymore

            },
            getName: function(){
                //get name in this order: Interface language, Default account language, en-US
                var possibleLangs = [LocaleResolver.getLocale(),LE.siteSettings.supportedLanguageSettings.getDefaultLanguage(),CONST.LANGUAGE["en-US"]];
                var chosenLangForNameToShow = _.find(possibleLangs,function(lang){
                    return  this.hasContentTitle(lang);
                },this);

                if (chosenLangForNameToShow) {
                    return this.getContentTitle(chosenLangForNameToShow);
                } else{
                    return  "";
                }

            },
            getCategories: function(){
                return this.get(KEYS.CATEGORIES);
            },
            setCategories: function(categoriesArray){
                this.set(KEYS.CATEGORIES,categoriesArray);
            },
            getLobs: function() {
                return this.get(KEYS.LOBS);
            },
            setLobs: function(lobIds) {
                this.set(KEYS.LOBS, lobIds);
            },
            getSkills: function(){
                return this.get(KEYS.SKILLS);
            },
            setSkills: function(skillsArray){
                this.set(KEYS.SKILLS, skillsArray);
            },
            isMismatchLobsAndSkills: function(skillsCollection) {
                var isMismatch = false;

                var contentSkillIds = this.getSkills();
                var contentLobIds = this.getLobs();
                if (!_.isEmpty(contentLobIds)) {
                    _.each(contentSkillIds, function(contentSkillId) {
                        var skillModel = skillsCollection.get(contentSkillId);
                        if (skillModel) {
                            var skillLobs = skillModel.getLobs();
                            if (!_.isEmpty(skillLobs)) {
                                isMismatch = _.intersection(skillLobs, contentLobIds).length === 0;
                                return !isMismatch; // break the iteration if a mismatch was found
                            }
                        }
                    });
                }

                return isMismatch;
            },
            _addNewContent: function(lang){
                this.langContentIndexMap[lang ] = this._getIndexForNewContent();
                this.set(this.getContentKey(lang),{"msg": "","title":"","lang": lang,"isDefault":false});
            },

            getContentTitleKey: function(lang){
                 return this.getContentKey(lang) +"." + KEYS.TITLE;
            },

            //jasonized settings
            getAllowedMacros: function(){
                return  ContentCannedUtilities.macros();
            },
            saveEmptyTooltip: function(){
                return ContentCannedUtilities.saveEmptyTooltip();
            },
            saveNoChangesTooltip: function () {
                return ContentCannedUtilities.saveNoChangesTooltip();
            },
            getHeaderTexts: function() {
                return ContentCannedUtilities.getHeaderTexts(this.isNew(),CANNED_TYPE_NAMES[this.get(KEYS.TYPE)]);
            },

            cleanData: function() {
                _.each(this.getData(),function(content){
                    if (!this.hasContentMessage(content.lang)  && !this.hasContentTitle(content.lang) ) {
                        this.set(this._getIsDefaultKey(content.lang),true);
                    }
                },this);

            }
        });
    });

    return ContentCannedModel;
});
